







































import Vue from "vue";

export default Vue.extend({
  name: "HeaderSection",
  props: {
    inverted: {
      type: Boolean,
      required: false
    },
    headline: {
      type: String,
      required: false
    },
    copytext: {
      type: String,
      required: false
    },
    numberOfButtons: {
      type: Number,
      required: false
    }
  }
});
